'use strict';

import {MessageBox} from 'uiv';
import limaTranslate from './lima-translate.js';

class LimaMessageBox {
  constructor() {
    this.options = {
      alert: {
        title: 'Alert',
        okText: 'OK',
        okType: 'primary',
        customClass: 'modal-primary',
        size: 'md',
        backdrop: false,
      },
      confirm: {
        title: 'Confirm',
        okText: 'Yes',
        okType: 'primary',
        cancelText: 'No',
        cancelType: 'default',
        //customClass: 'modal-danger modal-window-90percent',
        customClass: 'modal-primary',
        size: 'md',
        backdrop: false,
        autoFocus: 'cancel',
        reverseButtons: true,
      }
    };
  }
  translateDefault() {
    this.options.alert.title = limaTranslate('COMMON.CONFIRM');
    this.options.alert.okText = limaTranslate('COMMON.OK');
    this.options.confirm.title = limaTranslate('COMMON.CONFIRM');
    this.options.confirm.okText = limaTranslate('COMMON.YES');
    this.options.confirm.cancelText = limaTranslate('COMMON.NO');
  }
  alert(options) {
    if (typeof options === 'string') options = {content:options};
    return MessageBox.alert(_.defaults(options, this.options.alert)).then(res => true, err => false);
  }
  confirm(options) {
    if (typeof options === 'string') options = {content:options};
    return MessageBox.confirm(_.defaults(options, this.options.confirm)).then(res => true, err => false);
  }
  confirmDelete({name}) {
    return this.confirm({
      title: limaTranslate('COMMON.CONFIRM_DELETE'),
      content: `<p>${limaTranslate('COMMON.MSG.ARE_YOU_SURE_YOU_WANT_TO_DELETE', {name})}</p>`,
      html: true,
      okText: limaTranslate('COMMON.DELETE'),
      okType: 'danger',
      cancelText: limaTranslate('COMMON.CANCEL'),
      customClass: 'modal-danger'
    });
  }
}

export default new LimaMessageBox();